import { render, staticRenderFns } from "./ReasonChoice.vue?vue&type=template&id=9c0f9fa6&scoped=true&"
import script from "./ReasonChoice.vue?vue&type=script&lang=js&"
export * from "./ReasonChoice.vue?vue&type=script&lang=js&"
import style0 from "./ReasonChoice.vue?vue&type=style&index=0&id=9c0f9fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0f9fa6",
  null
  
)

export default component.exports